var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"editor",staticStyle:{"width":"100%","height":"100%"},attrs:{"type":"text","disabled":_vm.disabled,"maxlength":_vm.schema.max,"placeholder":_vm.schema.placeholder,"readonly":_vm.schema.readonly}})}
var staticRenderFns = []

export { render, staticRenderFns }